/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardPostWinConfigText } from './RewardPostWinConfigText';
import {
    RewardPostWinConfigTextFromJSON,
    RewardPostWinConfigTextFromJSONTyped,
    RewardPostWinConfigTextToJSON,
} from './RewardPostWinConfigText';
import type { RewardCategory } from './RewardCategory';
import {
    RewardCategoryFromJSON,
    RewardCategoryFromJSONTyped,
    RewardCategoryToJSON,
} from './RewardCategory';
import type { RarityCode } from './RarityCode';
import {
    RarityCodeFromJSON,
    RarityCodeFromJSONTyped,
    RarityCodeToJSON,
} from './RarityCode';

/**
 * 
 * @export
 * @interface WheelSegment
 */
export interface WheelSegment {
    /**
     * 
     * @type {boolean}
     * @memberof WheelSegment
     */
    winningSegment: boolean;
    /**
     * 
     * @type {RewardPostWinConfigText}
     * @memberof WheelSegment
     */
    postWinConfig?: RewardPostWinConfigText | null;
    /**
     * 
     * @type {RarityCode}
     * @memberof WheelSegment
     */
    rarity: RarityCode;
    /**
     * 
     * @type {RewardCategory}
     * @memberof WheelSegment
     */
    category: RewardCategory;
    /**
     * 
     * @type {string}
     * @memberof WheelSegment
     */
    rewardTypeId: string;
    /**
     * 
     * @type {string}
     * @memberof WheelSegment
     */
    name: string;
}



/**
 * Check if a given object implements the WheelSegment interface.
 */
export function instanceOfWheelSegment(value: object): value is WheelSegment {
    if (!('winningSegment' in value) || value['winningSegment'] === undefined) return false;
    if (!('rarity' in value) || value['rarity'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('rewardTypeId' in value) || value['rewardTypeId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function WheelSegmentFromJSON(json: any): WheelSegment {
    return WheelSegmentFromJSONTyped(json, false);
}

export function WheelSegmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): WheelSegment {
    if (json == null) {
        return json;
    }
    return {
        
        'winningSegment': json['winningSegment'],
        'postWinConfig': json['postWinConfig'] == null ? undefined : RewardPostWinConfigTextFromJSON(json['postWinConfig']),
        'rarity': RarityCodeFromJSON(json['rarity']),
        'category': RewardCategoryFromJSON(json['category']),
        'rewardTypeId': json['rewardTypeId'],
        'name': json['name'],
    };
}

export function WheelSegmentToJSON(value?: WheelSegment | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'winningSegment': value['winningSegment'],
        'postWinConfig': RewardPostWinConfigTextToJSON(value['postWinConfig']),
        'rarity': RarityCodeToJSON(value['rarity']),
        'category': RewardCategoryToJSON(value['category']),
        'rewardTypeId': value['rewardTypeId'],
        'name': value['name'],
    };
}

